
export default function IconLocationOffLine() {
  return (
    <svg id="fi_10922237" enableBackground="new 0 0 536.2 531.3"
      viewBox="0 0 536.2 531.3" xmlns="http://www.w3.org/2000/svg">
      <path d="m49 51.3c-10.2 10.2-10.3 26.7-.1 36.9 0 0 0 .1.1.1l64.8 64.8c-3 13.4-4.6 27.1-4.8 40.9 0 109.3 115.8 260 163.3 317.4 9.1 11.1 25.5 12.6 36.6 3.5 1.3-1.1 2.5-2.2 3.5-3.5 17-20.5 42.5-52.7 68.4-90.7l69.5 69.5c10.2 10.2 26.8 10.2 37 0s10.2-26.8 0-37l-401.4-401.9c-10.2-10.1-26.7-10.2-36.9 0zm243.5-40.9c-46.2 0-90.7 17.4-124.5 48.8l83.6 83.6c28.2-22.6 69.4-18 92 10.2 9.3 11.6 14.4 26.1 14.4 41s-5.2 29.4-14.7 40.9l93.1 93.1c23.1-46 39.6-92.8 39.6-134 .1-101.3-82-183.5-183.2-183.6-.1 0-.2 0-.3 0z">
      </path>
    </svg>
  )
}
